<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Ana Grup</label>
            <v-validator :errors="errors" parameter="MainGroupOfMaintenanceInventoryId" :watch="mainGroup"> 
              <v-select-list :disabled="editing" v-model="mainGroup" label="Name" placeholder="Ana Grup" :options="mainGroups"/>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Alt Grup</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name"> 
             <input type="text" v-model="value.Name" class="form-control" placeholder="Alt Grup" />
             </v-validator>
        </div>
    </div>
</template>

<script>
import MaintenanaceOperationsApi from '@/api/maintenance-operations'
export default {
    components:{
    },
    props:{
        value:Object,
        errors:Object,
        editing:Boolean
    },
    data(){
        return{
            mainGroups:[]
        }
    },
    mounted(){
        this.getMainGroups()
    },
    methods:{
        getMainGroups(){
            MaintenanaceOperationsApi.MainGroup.List().then(res=>{
                this.mainGroups = res.data.Data
            })
        }
    },
    computed:{
        mainGroup:{
            get:function(){
                return this.mainGroups.find(b=>b.Id==this.value.MainGroupOfMaintenanceInventoryId)
            },
            set:function(value){
                this.value.MainGroupOfMaintenanceInventoryId = value?.Id || null
            }
        }
    }
}
</script>

<style lang="scss">
</style>